import React from 'react'

/**
 * @param fill
 * @param rest
 * @returns {Element}
 * @constructor
 */
export function TrendingIcon ({
  fill,
  ...rest
}) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className='icon--arrowDown'
      viewBox='0 0 32 32'
      width={24}
      height={24}
      {...rest}
    >
      <path
        fill={fill}
        d='M29.9,9v8.4c0,.8-.6,1.4-1.4,1.4s-1.3-.5-1.4-1.2v-.2s0-3.5,0-3.5l-8,8c-.5.5-1.3.5-1.8.1h-.1c0-.1-5.4-5.5-5.4-5.5l-7.5,6.2c-.5.5-1.3.4-1.8,0h-.1c-.5-.7-.4-1.5,0-2h.1c0-.1,8.4-7.1,8.4-7.1.5-.4,1.2-.4,1.7,0h.1c0,.1,5.3,5.4,5.3,5.4l7.1-7.1h-3.7c-.7,0-1.3-.5-1.4-1.2v-.2c0-.7.5-1.3,1.2-1.4h.2s8.4,0,8.4,0Z'
      />
    </svg>
  )
}
